import React from "react";
import UnitClassicPage from "../../components/institutional/UnitClassicPage";
import { actuUnitPage } from "../../data/institutionalPageData";

export default function CorruptionUnit() {
  return <UnitClassicPage data={actuUnitPage} />;
}
